import { ElLoading } from "element-plus"

export class Loading {
    public static readonly instance: Loading = new Loading()

    private load: any = null
    private constructor() {
        
    }

    public open(text?: string): void {
        this.load?.close()

        this.load = ElLoading.service({
            lock: true,
            text,
            fullscreen: true
        })
    }

    public close(): void {
        this.load?.close()
        this.load = null
    }
}